module.exports = __webpack_public_path__ + "img/new_game.9c5cbf3c.svg";